export const GET_DEVICES = 'GET_DEVICES';
export const RELEASE_DEVICE = 'RELEASE_DEVICE';
export const RELEASE_DEVICE_ID = 'RELEASE_DEVICE_ID';
export const RELEASE_DEVICE_INIT  = 'RELEASE_DEVICE_INIT';